import EditDialog from "@/components/common/EditDialog";
import type { ExtendedEventViewT, SurgeryViewT } from "@/types/database/events";
import SurgeryForm from "./SurgeryForm";
import SurgerySummary from "./SurgerySummary";

interface Props {
    diaryId: string;
    trackerId?: string;
    eventId: string;
    organisationId: string;
    surgery: SurgeryViewT;
    event: ExtendedEventViewT;
    editable: boolean;
}

const SurgeryItem = (props: Props) => {
    const { surgery, editable, diaryId, eventId, organisationId } = props;

    return (
        <>
            <EditDialog
                label="Surgery"
                info={<SurgerySummary surgery={surgery} />}
                editable={editable}
            >
                <SurgeryForm
                    surgery={surgery as {
                        surgery_option_id?: string;
                        orthopaedic_area?: string;
                        side?:
                            | "Left"
                            | "Right"
                            | "N/A"
                            | "Both"
                            | "Middle"
                            | "";
                    }}
                    surgeryId={surgery.surgery_id as string}
                    diaryId={diaryId}
                    eventId={eventId}
                />
            </EditDialog>
        </>
    );
};

export default SurgeryItem;
